// import lifeStyleApi from 'api/lifeStyleApi';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { useMutation } from '@tanstack/react-query'
import { Switch, Typography } from 'antd'
import goodsGroupApi from 'api/goodsGroupApi'
import partnerApi from 'api/partnerApi'
import { goodsGroupQueries } from 'features/Category/screens/GoodsGroupScreen/queries'
import { useFormik } from 'formik'
import CustomLabel from 'general/components/CustomLabel'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import ToastHelper from 'general/helpers/ToastHelper'
import { generateSchema } from 'general/utils/YupSchema/Category'
import _ from 'lodash'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

/**
 *
 * @param {{
 * show: boolean,
 * onClose: function,
 * goodsGroupItem: object,
 * onExistDone: function,
 * onToggleClear: function,
 * }} props
 * @returns
 */

function ModalCreatePartner(props) {
  // MARK: --- Params ---
  const ref = useRef(null)
  const { t } = useTranslation()
  const { show, onClose, refetchList } = props
  const { mutateAsync, isPending } = useMutation({
    mutationKey: [{}, { action: 'crud' }],
    mutationFn: (params) => {
      return partnerApi.create(params).catch((error) => {
        console.log(error.response?.data)
      })
    },
  })

  // MARK: --- Functions ---

  const { submitForm, getFieldMeta, getFieldProps, setFieldValue, resetForm } =
    useFormik({
      initialValues: {
        namePartner: '',
        userNameRabbitmq: '',
        vhostRabbitmq: '',
        type: 'CREATE',
      },
      validationSchema: generateSchema(t).partner,
      enableReinitialize: true,
      onSubmit: async (values) => {
        const res = await mutateAsync(values)
        if (res?.result !== 'success') return
        ToastHelper.showSuccess('Thêm mới đối tác thành công')
        refetchList()
        resetForm()
        onClose()
      },
    })

  function handleClose(status) {
    onClose(status)
    resetForm()
  }

  return (
    <DraggableModal
      isOpen={show}
      title={'Thêm mới đối tác'}
      onOpenChange={handleClose}
      applyText={t('Save')}
      handleApplyChanges={submitForm}
      isLoading={isPending}
      ref={ref}
      styles={{
        body: {
          padding: '0px',
        },
      }}
    >
      <div className="container py-2 bg-light">
        <div className="row gap-3">
          {/* tên đối tác */}
          <div className="col-lg-12">
            <CustomLabel
              htmlFor="namePartner"
              isRequired
              text={'Tên đối tác'}
              fontWeight={600}
              fontSize={12}
              width={'100%'}
            />
            <CustomAntInput
              type="text"
              inputProps={{
                ...getFieldProps('namePartner'),
                onChange: (e) => setFieldValue('namePartner', e.target.value),
                placeholder: `Công ty cổ phần xxxx`,
                status:
                  getFieldMeta('namePartner').touched &&
                  getFieldMeta('namePartner').error
                    ? 'error'
                    : undefined,
              }}
            />
            {getFieldMeta('namePartner').touched &&
              getFieldMeta('namePartner').error && (
                <Typography.Text type="danger" className="font-size-sm">
                  {getFieldMeta('namePartner').error}
                </Typography.Text>
              )}
          </div>
          {/* tên tài khoản */}
          <div className="col-lg-12">
            <CustomLabel
              htmlFor="userNameRabbitmq"
              isRequired
              text={'Tên tài khoản'}
              fontWeight={600}
              fontSize={12}
              width={'100%'}
            />
            <CustomAntInput
              type="text"
              inputProps={{
                ...getFieldProps('userNameRabbitmq'),
                onChange: (e) =>
                  setFieldValue('userNameRabbitmq', e.target.value),
                placeholder: `Tên tài khoản`,
                status:
                  getFieldMeta('userNameRabbitmq').touched &&
                  getFieldMeta('userNameRabbitmq').error
                    ? 'error'
                    : undefined,
              }}
            />
            {getFieldMeta('userNameRabbitmq').touched &&
              getFieldMeta('userNameRabbitmq').error && (
                <Typography.Text type="danger" className="font-size-sm">
                  {getFieldMeta('userNameRabbitmq').error}
                </Typography.Text>
              )}
          </div>

          {/* vhost */}
          <div className="col-lg-12">
            <CustomLabel
              htmlFor="vhostRabbitmq"
              isRequired
              text={'Vhost'}
              fontWeight={600}
              fontSize={12}
              width={'100%'}
            />
            <CustomAntInput
              type="text"
              inputProps={{
                ...getFieldProps('vhostRabbitmq'),
                onChange: (e) => setFieldValue('vhostRabbitmq', e.target.value),
                placeholder: `Vhost`,
                status:
                  getFieldMeta('vhostRabbitmq').touched &&
                  getFieldMeta('vhostRabbitmq').error
                    ? 'error'
                    : undefined,
              }}
            />
            {getFieldMeta('vhostRabbitmq').touched &&
              getFieldMeta('vhostRabbitmq').error && (
                <Typography.Text type="danger" className="font-size-sm">
                  {getFieldMeta('vhostRabbitmq').error}
                </Typography.Text>
              )}
          </div>

          {/* vhost */}
          <hr></hr>
          <h5>Đầu mối liên hệ kỹ thuật đối tác để tạo tài khoản</h5>
          <div className="row">
            <div className="col-lg-6">
              <CustomLabel
                htmlFor="technicalContactFullName"
                // isRequired
                text={'Họ và tên'}
                fontWeight={600}
                fontSize={12}
                width={'100%'}
              />
              <CustomAntInput
                type="text"
                inputProps={{
                  ...getFieldProps('technicalContactFullName'),
                  onChange: (e) =>
                    setFieldValue('technicalContactFullName', e.target.value),
                  placeholder: `Nhập họ và tên`,
                  status:
                    getFieldMeta('technicalContactFullName').touched &&
                    getFieldMeta('technicalContactFullName').error
                      ? 'error'
                      : undefined,
                }}
              />
              {getFieldMeta('technicalContactFullName').touched &&
                getFieldMeta('technicalContactFullName').error && (
                  <Typography.Text type="danger" className="font-size-sm">
                    {getFieldMeta('technicalContactFullName').error}
                  </Typography.Text>
                )}
            </div>
            <div className="col-lg-6">
              <CustomLabel
                htmlFor="technicalContactEmail"
                // isRequired
                text={'Email'}
                fontWeight={600}
                fontSize={12}
                width={'100%'}
              />
              <CustomAntInput
                type="text"
                inputProps={{
                  ...getFieldProps('technicalContactEmail'),
                  onChange: (e) =>
                    setFieldValue('technicalContactEmail', e.target.value),
                  placeholder: `Nhập email`,
                  status:
                    getFieldMeta('technicalContactEmail').touched &&
                    getFieldMeta('technicalContactEmail').error
                      ? 'error'
                      : undefined,
                }}
              />
              {getFieldMeta('technicalContactEmail').touched &&
                getFieldMeta('technicalContactEmail').error && (
                  <Typography.Text type="danger" className="font-size-sm">
                    {getFieldMeta('technicalContactEmail').error}
                  </Typography.Text>
                )}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <CustomLabel
                htmlFor="technicalContactPhone"
                // isRequired
                text={'Số điện thoại'}
                fontWeight={600}
                fontSize={12}
                width={'100%'}
              />
              <CustomAntInput
                type="text"
                inputProps={{
                  ...getFieldProps('technicalContactPhone'),
                  onChange: (e) =>
                    setFieldValue('technicalContactPhone', e.target.value),
                  placeholder: `Nhập số điện thoại`,
                  status:
                    getFieldMeta('technicalContactPhone').touched &&
                    getFieldMeta('technicalContactPhone').error
                      ? 'error'
                      : undefined,
                }}
              />
              {getFieldMeta('technicalContactPhone').touched &&
                getFieldMeta('technicalContactPhone').error && (
                  <Typography.Text type="danger" className="font-size-sm">
                    {getFieldMeta('technicalContactPhone').error}
                  </Typography.Text>
                )}
            </div>
            <div className="col-lg-6"></div>
          </div>
          <hr></hr>
          <h5>Dịch vụ</h5>
          <div className="col-lg-12">
            <CustomLabel
              htmlFor="service"
              // isRequired
              text={'Tên dịch vụ'}
              fontWeight={600}
              fontSize={12}
              width={'100%'}
            />
            <CustomAntInput
              type="text"
              inputProps={{
                ...getFieldProps('service'),
                onChange: (e) => setFieldValue('service', e.target.value),
                placeholder: `Nhập tên dịch vụ`,
                status:
                  getFieldMeta('service').touched &&
                  getFieldMeta('service').error
                    ? 'error'
                    : undefined,
              }}
            />
            {getFieldMeta('service').touched &&
              getFieldMeta('service').error && (
                <Typography.Text type="danger" className="font-size-sm">
                  {getFieldMeta('service').error}
                </Typography.Text>
              )}
          </div>
          <div className="col-lg-12">
            <CustomLabel
              htmlFor="sizingDescription"
              // isRequired
              text={'Mô tả dịch vụ'}
              fontWeight={600}
              fontSize={12}
              width={'100%'}
            />
            <CustomAntInput
              type="textarea"
              inputProps={{
                ...getFieldProps('sizingDescription'),
                onChange: (e) =>
                  setFieldValue('sizingDescription', e.target.value),
                placeholder: `Nhập mô tả dịch vụ`,
                status:
                  getFieldMeta('sizingDescription').touched &&
                  getFieldMeta('sizingDescription').error
                    ? 'error'
                    : undefined,
              }}
            />
            {getFieldMeta('sizingDescription').touched &&
              getFieldMeta('sizingDescription').error && (
                <Typography.Text type="danger" className="font-size-sm">
                  {getFieldMeta('sizingDescription').error}
                </Typography.Text>
              )}
          </div>
          <hr></hr>
          <h5>Ước lượng</h5>
          <div className="col-lg-12">
            <CustomLabel
              htmlFor="transactionVolumeByPeriodQuarter"
              // isRequired
              text={
                'Dự kiến lượng GD phát sinh trong ngày/tháng/quý : (Theo thời điểm, do đặc thù) 3,000 GD/ Quý'
              }
              fontWeight={600}
              fontSize={12}
              width={'100%'}
            />
            <CustomAntInput
              type="text"
              inputProps={{
                ...getFieldProps('transactionVolumeByPeriodQuarter'),
                onChange: (e) =>
                  setFieldValue(
                    'transactionVolumeByPeriodQuarter',
                    e.target.value,
                  ),
                placeholder: `Nhập dự kiến lượng GD phát sinh trong ngày/tháng/quý`,
                status:
                  getFieldMeta('transactionVolumeByPeriodQuarter').touched &&
                  getFieldMeta('transactionVolumeByPeriodQuarter').error
                    ? 'error'
                    : undefined,
              }}
            />
            {getFieldMeta('transactionVolumeByPeriodQuarter').touched &&
              getFieldMeta('transactionVolumeByPeriodQuarter').error && (
                <Typography.Text type="danger" className="font-size-sm">
                  {getFieldMeta('transactionVolumeByPeriodQuarter').error}
                </Typography.Text>
              )}
          </div>
          <div className="row">
            <div className="col-lg-6">
              <CustomLabel
                htmlFor="peakDayTransactions"
                // isRequired
                text={'Ngày giao dịch cao điểm'}
                fontWeight={600}
                fontSize={12}
                width={'100%'}
              />
              <CustomAntInput
                width={400}
                type="number"
                inputProps={{
                  ...getFieldProps('peakDayTransactions'),
                  onChange: (inputVal) =>
                    setFieldValue(
                      'peakDayTransactions',
                      _.isNumber(inputVal) ? inputVal : null,
                    ),
                  placeholder: `1000`,
                  status:
                    getFieldMeta('peakDayTransactions').touched &&
                    getFieldMeta('peakDayTransactions').error
                      ? 'error'
                      : undefined,
                  style: {
                    width: '100%',
                    padding: 0,
                  },
                }}
              />
              {getFieldMeta('peakDayTransactions').touched &&
                getFieldMeta('peakDayTransactions').error && (
                  <Typography.Text type="danger" className="font-size-sm">
                    {getFieldMeta('peakDayTransactions').error}
                  </Typography.Text>
                )}
            </div>
            <div className="col-lg-6">
              <CustomLabel
                htmlFor="peakDayTransactions"
                // isRequired
                text={'Ngày giao dịch thông thường'}
                fontWeight={600}
                fontSize={12}
                width={'100%'}
              />
              <CustomAntInput
                width={400}
                type="number"
                inputProps={{
                  ...getFieldProps('normalDayTransactions'),
                  onChange: (inputVal) =>
                    setFieldValue(
                      'normalDayTransactions',
                      _.isNumber(inputVal) ? inputVal : null,
                    ),
                  placeholder: `1000`,
                  status:
                    getFieldMeta('normalDayTransactions').touched &&
                    getFieldMeta('normalDayTransactions').error
                      ? 'error'
                      : undefined,
                  style: {
                    width: '100%',
                    padding: 0,
                  },
                }}
              />
              {getFieldMeta('normalDayTransactions').touched &&
                getFieldMeta('normalDayTransactions').error && (
                  <Typography.Text type="danger" className="font-size-sm">
                    {getFieldMeta('normalDayTransactions').error}
                  </Typography.Text>
                )}
            </div>
          </div>

          {/* <div className="col-lg-12">
            <CustomLabel
              htmlFor="status"
              text={t('Status')}
              fontWeight={600}
              fontSize={12}
              width={100}
            />
            <Switch
              checked={getFieldProps('status').value === 'ACTIVE'}
              onChange={(checked) => {
                setFieldValue('status', checked ? 'ACTIVE' : 'INACTIVE')
              }}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
            ></Switch>
          </div> */}
        </div>
      </div>
    </DraggableModal>
  )
}

export default ModalCreatePartner
